import { ForwardedRef } from 'react';

export enum MessageCenterScreen {
    HOME = 'home',
    NEW_MESSAGE = 'newMessage',
    CHAT = 'chat',
}

export type ScreenType = MessageCenterScreen | string;
export type ParamsType = { [key: string]: any };

export interface NavigationContextType {
    stack: Array<{ screen: ScreenType; params?: ParamsType }>;
    currentScreen?: ScreenType;
    params: ParamsType;
}

export interface NavigationUpdateContextType {
    navigateToPage: (screen: ScreenType, params?: ParamsType) => void;
    goBack: () => void;
    push: (screen: ScreenType, params?: ParamsType) => void;
    pop: () => void;
    clean: () => void;
}

interface NavigationContextProviderProps {
    children: React.ReactNode;
}

export interface NavigationProviderProps extends NavigationContextProviderProps {
    navigationRef?: ForwardedRef<NavigationUpdateContextType>;
}
